<template>
  <div>
    <div class="modal-backdrop"></div>

    <div class="modal task" :class="{ customLoader: loading }">
      <div class="content">
        <div class="pull-right">
          <div class="btn-close" @click="close()"></div>
        </div>

        <ConditionBuilderComponent
          v-show="!loading"
          ref="conditionComponentRef"
          :task="{ input: getFilteredInputForConditionBuilder }"
          @onContentChange="onContentChange"
          :defaultConditions="task.props.conditions"
        ></ConditionBuilderComponent>
      </div>

      <LoadingSpinner loadingCaption="Wird gespeichert..." v-show="loading" />
    </div>
  </div>
</template>

<script>
import { ConditionBuilderComponent } from '@codelos.io/condition-builder';
import '@codelos.io/condition-builder/dist/condition-builder.css';
import LoadingSpinner from '../widgets/LoadingSpinner.vue';

export default {
  name: 'conditionBuilderWarp',

  props: {
    task: Object,
  },

  data() {
    return {
      outputContent: [],
      loading: false,
    };
  },
  methods: {
    onContentChange(event) {
      this.task.props.conditions = event;
    },

    async close() {
      this.loading = true;
      await this.saveAsOutput();
      setTimeout(() => {
        this.loading = false;
        this.$emit('close');
      }, 1000);
    },

    async saveAsOutput() {
      this.$set(this.task, 'output', this.task.input);
      try {
        const res = await this.$refs.conditionComponentRef.getConditionOutput();
        this.$emit('conditionBuilderResponse', {
          task: this.task,
          res,
        });
      } catch (err) {
        this.$emit('conditionBuilderResponse', { task: this.task, res: false });
      }
    },
  },
  created() {
    if (this.task.input && this.task.input.length > 0) {
      const tmpConditions = JSON.parse(
        JSON.stringify(this.task.props.conditions)
      );

      tmpConditions.forEach((conditionBlock) => {
        conditionBlock.forEach((singleCondition) => {
          const el1FoundedNewVal = this.task.input.find(
            (input) => input.name === singleCondition.el1.name
          );

          const el2FoundedNewVal = this.task.input.find(
            (input) => input.name === singleCondition.el2.name
          );

          singleCondition.el1.value = el1FoundedNewVal
            ? el1FoundedNewVal.value
            : singleCondition.el1.value;
          singleCondition.el2.value = el2FoundedNewVal
            ? el2FoundedNewVal.value
            : singleCondition.el2.value;
        });
      });
      this.task.props.conditions = tmpConditions;
    }
  },
  computed: {
    getFilteredInputForConditionBuilder() {
      const unwantedTypes = ['file'];
      return this.task.input.filter(
        (input) =>
          input.label !== 'codelosSettings' &&
          !unwantedTypes.includes(input.type)
      );
    },
  },

  components: {
    ConditionBuilderComponent,
    LoadingSpinner,
  },
};
</script>

<style scoped>
.modal-backdrop {
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background-color: rgba(0, 0, 0, 0.3);
  display: flex;
  justify-content: center;
  align-items: center;
}

.modal {
  background: #ffffff;
  border-radius: 4px;
  display: block;
  width: 80%;
  height: 98%;
  text-align: left;
  font-family: 'Open Sans', open-sans, sans-serif;
  -webkit-font-smoothing: antialiased;
  font-size: 12px;
  line-height: 17px;
  color: #5f697a;
  top: 0;
  position: absolute;
  left: 10%;
  top: 1%;
}

.content {
  background-color: #fff;
  width: 100%;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  text-align: center;
}

.pull-right {
  float: right;
}

::v-deep .column-selector,
::v-deep .row-selector {
  box-shadow: unset;
  padding: 0;
}

::v-deep input {
  box-sizing: border-box;
}
::v-deep .codelos-page-content {
  text-align: left;
  font-size: 16px;
  color: #212529;
}
::v-deep .element-block {
  line-height: 1.5;
}

::v-deep .modal-backdrop.custom-backdrop {
  background: transparent;
}
::v-deep .codelos-dropdown-child,
::v-deep .codelos-dropdown {
  box-sizing: border-box;
}
::v-deep .codelos-dropdown-item {
  line-height: 1.5;
}
.btn-close {
  position: relative;
  z-index: 9;
  top: 10px;
  right: 10px;
}

::v-deep .accordion-wrapper,
::v-deep .input-item,
::v-deep .dropdown-item {
  box-sizing: border-box;
}

::v-deep input {
  min-height: 41px;
}
::v-deep .dropdown-menu.show {
  bottom: unset;
}

::v-deep .modal.custom-modal {
  width: 98% !important;
  max-width: 100%;
  left: unset;
  right: unset;
  box-sizing: border-box;
  box-shadow: none;
  border: none;
}

.progress-icon-wrapper {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  width: 100%;
  text-align: center;
}

.progress-icon-wrapper .progress-icon {
  left: unset;
  margin: 0 auto;
  top: unset;
  margin-top: 30px;
}
.progress-icon-wrapper .progress-icon:after {
  border-color: #313745 transparent #313745 transparent;
}
</style>
